import { request as __request } from "../core/request.js";
export class StanUrzDzeniaService {
    /**
     * Get Complete Parcel Locker State
     * Metoda do pobrania kompletnego stanu paczkomatu wraz z informacjami o zajętości paczkomatu
     * @returns ParcelLockerState Operacja zakończyła się powodzeniem.
     * @throws ApiError
     */
    static async getPlState() {
        const result = await __request({
            method: 'GET',
            path: `/api/apm/states`,
            errors: {
                404: `Nie znaleziono zasobu.`,
                500: `Wystąpił nieoczekiwany błąd po stronie serwera usługi.`,
            },
        });
        return result.body;
    }
}
//# sourceMappingURL=StanUrzDzeniaService.js.map